<template>
  <CFooter class="footer-distributed" id="footer">
    <div class="footer-left col-sm-4 col-xs-12 col-md-4">
      <router-link to="/site/index"
        ><img
          loading="lazy"
          max-width="200px"
          width="200"
          height="73"
          class="hidden-xs hidden-sm"
          src="@/assets/images/TheFactoryHKAgenericoSmall.webp"
          alt="The Factory HKA Impresoras Fiscales"
      /></router-link>
      <CRow style="margin-top: 10px">
        <CCol xs="2" sm="1">
          <div class="printer-bg">
            <div class="container-printer">
              <div class="receipt"></div>
              <div class="printer"><p class="line">-</p></div>
            </div>
          </div>
        </CCol>
        <CCol xs="6" sm="6" class="footer-productos">
          <p>Productos</p>
        </CCol>
      </CRow>

      <p class="footer-links">
        <router-link to="/productos/impresoras">Impresoras</router-link>
        <span> · </span>
        <router-link to="/productos/cajas">Cajas Registradoras</router-link>
        <span> · </span>
        <router-link to="/productos/captura"
          >Dispositivos de Transmisión</router-link
        >
        <span> · </span>
        <router-link to="/productos/balanzas">Balanzas</router-link>
        <span> · </span>
        <router-link to="/productos/perifericos"
          >Periféricos y otros</router-link
        >
        <span> · </span>
        <router-link to="/hkaprint">HKA Print</router-link>
        <span> · </span>
        <router-link to="/papel">Papel Térmico</router-link>
        <span> · </span>
        <router-link to="/productos/puntosdeventafiscal">
          Puntos de Venta Fiscal
          <CBadge color="danger"> Nuevo </CBadge>
        </router-link>
        <span> · </span>
      </p>
      <p class="footer-company-name">The Factory HKA C.A. RIF : J-312171197</p>
    </div>
    <div class="footer-center col-sm-4 col-xs-12 col-md-4">
      <CRow>
        <div class="container-pulse">
          <div class="marker"></div>
          <div class="pulse"></div>
        </div>
      </CRow>
      <br />
      <CRow>
        <p class="bottom2">
          {{ actualContact.address }}
        </p>
      </CRow>
      <br />
      <div>
        <div class="div-phone">
          <i class="Phone is-animating"></i>
        </div>
        <p class="bottom2">
          <a :href="actualContact.phoneNumber"
            >{{ actualContact.phone_number }}
            <img
              height="30"
              width="30"
              style="margin-top: 0px"
              :src="$imagePath + 'countries/banderas/ve.webp'"
              alt="The Factory HKA Colombia"
          /></a>
        </p>
      </div>
      <br />
      <div class="bottom">
        <CRow>
          <CCol xs="6" sm="2">
            <router-link to="/contacto/index">
              <div class="envelope">
                <div class="back"></div>
                <div class="letter">
                  <div class="text">HOLA!</div>
                </div>
                <div class="front"></div>
                <div class="top"></div>
                <div class="shadow"></div>
              </div>
            </router-link>
          </CCol>
          <CCol xs="6" sm="4" class="align-self-center">
            <p><router-link to="/contacto/index"> Contacto </router-link></p>
          </CCol>
        </CRow>
      </div>
    </div>
    <div class="footer-right col-sm-4 col-xs-12 col-md-4">
      <p class="footer-company-about">
        <span>Acerca de The Factory HKA</span>
        Somos una empresa internacional, ágil y moderna con oficinas en USA,
        Venezuela, Perú, Bolivia, México, República Dominicana, Colombia y
        Panamá, especializados en impresoras fiscales y facturación eletrónica
      </p>
      <div class="footer-icons">
        <div class="icons-wrapper">
          <a
            target="_blank"
            href="https://www.facebook.com/factoryhka/"
            name="facebook"
            ><CIcon
              alt="facebook"
              aria-label="facebook"
              class="icon-face icon-animation"
              icon="cibFacebook"
              size="xxl"
          /></a>
          <a
            target="_blank"
            href="https://twitter.com/TheFactoryHKA"
            name="twitter"
            ><CIcon
              alt="twitter"
              aria-label="twitter"
              class="icon-twitter icon-animation"
              icon="cibTwitter"
              size="xxl"
          /></a>
          <a
            target="_blank"
            href="https://www.instagram.com/thefactory.hka/"
            name="instagram"
            ><CIcon
              alt="instagram"
              aria-label="instagram"
              class="icon-instagram icon-animation"
              icon="cibInstagram"
              size="xxl"
          /></a>
        </div>
      </div>
      <p>
        <router-link
          to="/privacidad/index"
          style="color: #fff; text-decoration: none"
        >
          Políticas de Privacidad
        </router-link>
      </p>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      contacts: [],
      actualContact: [],
    }
  },
  beforeCreate() {
    let post = {
      country: this.$country,
    }
    let url = '/v1/contactanos/data'
    if (process.env.NODE_ENV != 'development') {
      url = `${location.protocol}//${location.hostname}${this.$api}${url}`
    }

    this.axios(url, {
      method: 'POST',
      mode: 'no-cors',
      data: post,
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + this.$token,
      },
      credentials: 'same-origin',
      crossdomain: true,
    })
      .then((resp) => {
        if (resp.data.result.approved == true) {
          this.actualContact = resp.data.result.data
        }
      })
      .catch((error) => {
        if (
          error.response.status == 401 ||
          error.response.data.type == 'InvalidArgumentException'
        ) {
          this.$router.push('/pages/login')
        }
      })
  },
}
</script>
